import { BASE_URL } from '../../../../config/environmentConfig';
import { ON_BOARDING_ROUTES } from '../../../utils/constatns';
import { merchantActionTypes } from '../action-types';
import * as React from 'react';
import { IAction } from '../merchant-interfaces';
import { GET } from '../../store-helper';
import { IPaginationData } from '../../../interfaces/funds';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import axios from 'axios';
import { errorAlert } from '../../../components/ToastMessage';

interface IFetchApplicationData {
	dispatch: React.Dispatch<IAction>,
	applicationId: string,
}
export const fetchRegularApplicationData = async ({
	dispatch,
	applicationId,
}: IFetchApplicationData): Promise<void> => {
	try {
		const data = await GET({ pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}` });
		console.log('convertedData--2', data);
		// if (data?.record) {
		// 	const formikInitialValue = convertToApplicationInitialData(data?.record);
		// 	let convertedFees = {};
		// 	if (data?.record?.logoUrl) {
		// 		setUploadedFile(data?.record?.logoUrl);
		// 	}
		// 	if (data?.record?.fees) {
		// 	const newFees: any = {};
		//
		// 		data?.record?.fees.forEach(el => {
		// 			switch (el.name) {
		// 				case 'Percentage':
		// 					newFees.percentage = el.amount / 100;
		// 					newFees.percentageId = el.id;
		// 					newFees.minFeeAmount = el?.minimumFeeAmount ? el?.minimumFeeAmount / 100 : '';
		// 					break;
		// 				case 'Fee Amount':
		// 					newFees.feeAmount = el.amount / 100;
		// 					newFees.feeAmountId = el.id;
		// 					break;
		// 				case 'Chargeback Fee':
		// 					newFees.chargeback = el.amount / 100;
		// 					newFees.chargebackId = el.id;
		// 					break;
		// 				case 'Refund Fee':
		// 					newFees.refundFee = el.amount / 100;
		// 					newFees.refundFeeId = el.id;
		// 					break;
		// 				case 'Risk Fee':
		// 					newFees.riskFee = el.amount / 100;
		// 					newFees.riskFeeId = el.id;
		// 					break;
		// 			}
		// 		});
		// 		convertedFees = convertToInitialFeeValues(newFees);
		// 	}
		// 	const convertedApplicationData = {
		// 		...formikInitialValue,
		// 		...convertedFees
		// 	};
		// 	formik.setValues(convertedApplicationData);
		// }
		dispatch({ type: merchantActionTypes.FETCH_IS_STANDARD_FEE_SELECTED, payload: data?.record?.standardFeeSelected || false });
		dispatch({ type: merchantActionTypes.FETCH_APPLICATION_DATA, payload: data?.record ?? null });
	} catch (e) {
		console.log(e);
		dispatch({ type: merchantActionTypes.FETCH_FAIL });
	}
};

export const setToDefaultApplicationData = (dispatch: React.Dispatch<IAction>): void => {
	dispatch({ type: merchantActionTypes.SET_APPLICATION_DETAILS_DATA_DEFAULT });
};


export const fetchApplicationsList = async (parsedSearch: IApplicationFilters): Promise<IPaginationData> => {
	try {
		if (parsedSearch?.orderBy === 'false') {
			parsedSearch.orderBy = '';
			parsedSearch.sortField = '';
		}

		const data = await GET({
			pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}`,
			params: parsedSearch,
		});

		return data?.results;

	} catch (e) {
		console.log('fetchApplicationsListV2 error', e);
	}
};

export const fetchApplicationSummary = async (dispatch: React.Dispatch<IAction>, searchParams: IApplicationFilters): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.SET_APPLICATION_SUMMARY_LOADING, payload: true });

		const data = await GET({
			pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/summary`,
			params: searchParams
		});
		console.log('data', data);
		const filteredData = Object.values(data || {}).filter((el: any) => el);
		console.log('filteredData', filteredData);
		dispatch({ type: merchantActionTypes.FETCH_APPLICATION_SUMMARY, payload: filteredData || [] });
	} catch (e) {
		dispatch({ type: merchantActionTypes.FETCH_APPLICATION_SUMMARY, payload: [] });
		console.log('fetchApplicationSummary error', e);
	}
};

export interface ISetDocuments {
	id: string;
	fileList: any[];
	uploadedFiles?: any[];
}
export const setApplicationDocuments = async ({ id, fileList, uploadedFiles }: ISetDocuments): Promise<void> => {
	try {
		const formData = new FormData();
		fileList.forEach((file) => {
			formData.append(`file_${file?.name}`, file?.blobFile);
		});

		const params = {
			documents: uploadedFiles || [],
		};
		formData.append('documents', JSON.stringify(params));

		// Use enhanced PUT helper with FormData support
		// await PUT({
		// 	pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/${id}/documents`,
		// 	body: formData,
		// 	headers: {
		// 		'Content-Type': 'multipart/form-data',
		// 	},
		// });

		await axios.put(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/${id}/documents`, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});

	} catch (error) {

		sendSentryMessage({ name: `PUT Set application documents error`, context: error });
		console.log('setApplicationDocuments error', error);

		errorAlert({
			title: 'Failed to upload documents',
			duration: 2000,
			closable: true
		});

		// Re-throw error for caller to handle if needed
		throw error;
	}
};

export const setApplicationEditStatus = ({ dispatch, value }): void => {
	dispatch({ type: merchantActionTypes.SET_APPLICATION_EDIT_STATUS, payload: value });
};

export const fetchApplicationDetailsLogs = async ({ dispatch, applicationId }): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.SET_APPLICATION_DETAILS_LOGS_LOADING, payload: true });

		const data = await GET({
			pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/${applicationId}/activities`,
		});

		let formattedActivityLogsData = [];
		if (data?.activities?.length) {
			formattedActivityLogsData = data.activities.map((item) => ({
				...item,
				name: item?.category,
				informationLevel: 2,
				data: item?.meta,
				meta: item?.updateMessage,
				note: item?.note,
			}));
		}

		dispatch({ type: merchantActionTypes.FETCH_APPLICATION_DETAILS_LOGS, payload: formattedActivityLogsData });
	} catch (e) {
		console.log('fetchApplicationDetailsLogs error', e);
		dispatch({ type: merchantActionTypes.FETCH_APPLICATION_DETAILS_LOGS, payload: [] });
	}
};

export interface IApplicationFilters {
	statuses?: string[],
	operationsStatuses?: string[],
	riskStatuses?: string[],
	pageNumber?: string | number,
	pageSize?: string | number,
	query?: string,
	partnerId?: string,
	integrationPartnerId?: string,
	sortField?: string,
	orderBy?: string,
}
